<template>
  <div class="checkbox--container" :class="size">
    <div v-if="isDisabled">
      <div v-if="isSelected">
        <Icon icon-name="check" :width="24" :height="24" stroke-color="#0fa0de">
          <CheckDisabled></CheckDisabled>
        </Icon>
      </div>
      <div v-else class="checkbox path disabled">
        <input :id="text" type="checkbox" :checked="false" :disabled="true" />
      </div>
    </div>
    <label v-else class="checkbox path">
      <div>
        <input
          :id="text"
          type="checkbox"
          :checked="isSelected"
          :disabled="isDisabled"
          :required="isRequired"
          @click.self="emitState"
        />
        <Icon
          v-if="isSelected"
          icon-name="check"
          :width="24"
          :height="24"
          icon-color="#0fa0de"
          :should-fire="false"
        >
          <Check></Check>
        </Icon>
      </div>
    </label>
    <p v-if="text" class="text">{{ text }}</p>
  </div>
</template>

<script>
import Icon from "@/components/shared/Icons/Icon";
import Check from "@/components/shared/Icons/check.svg";
import CheckDisabled from "@/components/shared/Icons/check-disabled.svg";
export default {
  name: "Checkbox",
  components: { Icon, Check, CheckDisabled },
  props: {
    isSelected: { type: Boolean },
    text: { type: String },
    isDisabled: { type: Boolean, default: false },
    isRequired: { type: Boolean, default: false },
    size: { type: String, default: "" },
  },
  methods: {
    emitState() {
      this.$emit("onClick", !this.isSelected);
    },
  },
};
</script>

<style scoped lang="scss">
.checkbox--container {
  display: flex;
  align-items: center;
  cursor: default;
}
.checkbox {
  --background: #fff;
  --border: #d1d6ee;
  --border-hover: #bbc1e1;
  --border-active: #1e2235;
  --tick: #fff;

  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
}

.checkbox {
  input {
    width: 24px;
    height: 24px;
    display: block;
    -webkit-appearance: none;
    -moz-appearance: none;
    position: relative;
    outline: none;
    background: var(--background);
    border: none;
    margin: 0;
    padding: 0;
    border-radius: 4px;
    transition: box-shadow 0.3s;
    box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--border));
  }
  &:not(.disabled) {
    input {
      cursor: pointer;
    }
  }
  &.disabled {
    input {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
.checkbox svg {
  position: absolute;
  top: 0;
  left: 0;
  padding: 4px;
  fill:var(--blue);
}
g {
  stroke-width: 1px;
}
.checkbox .text,
.checkbox--container .text {
  margin: 0 10px;
  color: var(--black);
  cursor: default;
}
.small .text {
  font-size: var(--font-size__small);
  color: var(--gray__darkest);
}
</style>
